// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2N21C","col":"styles_col__a6OvU","fulfillmentStatus":"styles_fulfillmentStatus__1Fg6Z","emailCol":"styles_emailCol__1pw2s"};